const stages = {
  development: {
    base: '',
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    camGateway: process.env.REACT_APP_CAM_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    apiPath: '',
    camRoot: 'cam',
    galaxyRoot: '/',
    hrefRoot: 'cam/',
    imageRoot: '',
    ticketRoot: '/',
    mlGateway: process.env.REACT_APP_ML_URL
  },
  production: {
    base: '',
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    apiGateway: '/api',
    camGateway: process.env.REACT_APP_CAM_URL,
    galaxyRoot: '/galaxy',
    imageRoot: process.env.PUBLIC_URL
      ? `${process.env.PUBLIC_URL}${process.env.REACT_APP_CDN_SUFFIX}`
      : process.env.PUBLIC_URL,
    camRoot: '/packages/banyan/build/',
    ticketRoot: '/packages/mangifera/build/',
    mlGateway: process.env.REACT_APP_ML_URL
  }
};

export default {
  ...stages[process.env.NODE_ENV]
};
